import LoginStyle from './Login.module.scss';
import { LoadingButton } from '@mui/lab';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { OtpInput } from 'reactjs-otp-input';
import { toast } from 'react-toastify';
import { loginUser, verifyOtp } from '../../apis/authSlice';
import { isDoctor } from '../../utils/findUserRole';

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [step, setStep] = useState(1);
  const [user, setUser] = useState({
    email: '',
    otp: '',
    keepMeLoggedIn: false,
  });

  const [isChecked, setIsChecked] = useState(false);

  const { authLoading } = useSelector((state) => state.authData);

  const handelOnChange = (e) => {
    const { name, value } = e.target;
    // always convert email to lowercase on input
    const formattedValue = name === 'email' ? value.toLowerCase() : value;
    setUser((oldData) => ({
      ...oldData,
      [name]: formattedValue,
    }));
  };

  const handelOnKeepChange = () => {
    setIsChecked(!isChecked);
  };

  const handelVerifyOTP = async (e) => {
    e.preventDefault();
    if (!user.otp) {
      return toast.error('Please enter OTP');
    }
    if (!user.email) {
      return toast.error('Please enter email');
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user.email)) {
      return toast.error('Please enter valid email');
    }

    const finalData = {
      email: user.email.toLowerCase(),
      otp: user.otp,
    };
    const response = await dispatch(verifyOtp(finalData));

    if (response.type.includes('fulfilled')) {
      toast.success(response?.payload?.message);
      navigate( isDoctor() ? '/calenderPage' : '/dashboard');
    } else {
      toast.error(response?.payload?.message);
    }
  };

  const handelLogin = async (e) => {
    e.preventDefault();

    if (!user.email) {
      return toast.error('Please enter email');
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user.email)) {
      return toast.error('Please enter valid email');
    }

    // ensure email is lowercase before sending
    const payload = { ...user, email: user.email.toLowerCase(), keepMeLoggedIn: isChecked };
    const response = await dispatch(loginUser(payload));
    if (response.type.includes('fulfilled')) {
      toast.success(response?.payload?.message);
      setStep(2);
    } else {
      toast.error(response?.payload?.message);
    }
  };

  return (
    <div className={LoginStyle.page}>
      <div className={LoginStyle.bgAnimation} aria-hidden="true">
        <span className={`${LoginStyle.floatShape} ${LoginStyle.shapeOne}`} />
        <span className={`${LoginStyle.floatShape} ${LoginStyle.shapeTwo}`} />
        <span className={`${LoginStyle.floatShape} ${LoginStyle.shapeThree}`} />
        <span className={`${LoginStyle.floatShape} ${LoginStyle.shapeFour}`} />
        <span className={`${LoginStyle.pulseRing} ${LoginStyle.ringOne}`} />
        <span className={`${LoginStyle.pulseRing} ${LoginStyle.ringTwo}`} />
      </div>
      <div className={LoginStyle.container}>
        {step === 1 ? (
          <div className={LoginStyle.formPanel}>
            <div className={LoginStyle.formHeader}>
              <h2>Welcome back</h2>
              <p>Sign in using your registered email to continue.</p>
            </div>
            <div className={LoginStyle.formBox}>
              <form onSubmit={handelLogin}>
                <input
                  type="email"
                  placeholder="Enter Email"
                  className={LoginStyle.input}
                  name="email"
                  value={user.email}
                  onChange={handelOnChange}
                />
                <div className={LoginStyle.keep}>
                  <input
                    type="checkbox"
                    name="keepMeLoggedIn"
                    className={LoginStyle.keepcheckbox}
                    value={isChecked}
                    onChange={handelOnKeepChange}
                    id="isChecked"
                  />
                  <label className={LoginStyle.keepText} htmlFor="isChecked">
                    Keep Me Logged In
                  </label>
                </div>
                <div className={LoginStyle.btnBox}>
                  <LoadingButton
                    className={LoginStyle.submitButton}
                    loading={authLoading}
                    type="submit"
                    loadingPosition="end"
                  >
                    <span>Submit</span>
                  </LoadingButton>
                </div>
              </form>
              <a
                className={LoginStyle.appointmentLink}
                href="/patientcalendar"
                target="_blank"
                rel="noopener noreferrer"
              >
                Book Your Appointment Instantly
              </a>
            </div>
          </div>
        ) : (
          <div className={LoginStyle.formPanel}>
            <div className={LoginStyle.formHeader}>
              <h2>Enter OTP</h2>
              <p>We have sent a 6-digit verification code to your email.</p>
            </div>
            <div className={LoginStyle.formBox}>
              <form className={LoginStyle.otpForm} onSubmit={handelVerifyOTP}>
                <div className={LoginStyle.otpBox}>
                  <OtpInput
                    value={user.otp}
                    onChange={(value) => {
                      setUser({ ...user, otp: value });
                    }}
                    numInputs={6}
                    inputStyle={LoginStyle.OtpInput}
                    isInputNum
                  />
                </div>
                <LoadingButton
                  loading={authLoading}
                  className={LoginStyle.submitButton}
                  loadingPosition="end"
                  type="submit"
                >
                  <span>Verify</span>
                </LoadingButton>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
